module.exports = __webpack_public_path__ + "img/left-boot.5c640e97.jpg";